export default {
  PRODUCT_REPEATER_CLASS: 'products columns-4',

  FACET_BAR_WHEELS_TIRES_TITLE_CLASS: 'facettitle',
  FACET_BAR_WHEELS_TIRES_BODY_CLASS: 'facetbody',

  BUTTON_PRIMARY_CLASS: 'btn btn-primary',
  BUTTON_SECONDARY_CLASS: 'btn btn-secondary',

  SELECT_YOUR_VEHICLE: 'Filter By Vehicle',
  CHANGE_VEHICLE: 'Change',
  DISCARD_VEHICLE: 'Clear',
  GO_TEXT: 'FILTER',
  VERIFY_FITMENT_TITLE: 'Verify This Fits',
  VERIFY_FITMENT_FITS: 'This product fits your',
  VERIFY_FITMENT_NOT_FIT: 'This product does not fit your',

  GARAGE_TITLE: '',
  GARAGE_ICON: '<span class="garage-icon fa fa-car"></span>',

  SEARCH_BOX_PLACEHOLDER: 'Search for a product, brand, or SKU...',
};
